import { render, staticRenderFns } from "./FormRegister.vue?vue&type=template&id=99f2c7cc&scoped=true"
import script from "./FormRegister.vue?vue&type=script&lang=js"
export * from "./FormRegister.vue?vue&type=script&lang=js"
import style0 from "./FormRegister.vue?vue&type=style&index=0&id=99f2c7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f2c7cc",
  null
  
)

export default component.exports